var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanFeature5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87990",
    "data-name": "Group 87990",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.845,
    height: 24.69,
    viewBox: "0 0 23.845 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25576",
    "data-name": "Rectangle 25576",
    width: 23.846,
    height: 24.69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25575",
    "data-name": "Rectangle 25575",
    width: 23.845,
    height: 24.69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25574",
    "data-name": "Rectangle 25574",
    width: 3.89,
    height: 6.04,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87989",
    "data-name": "Group 87989",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87988",
    "data-name": "Group 87988",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87987",
    "data-name": "Group 87987",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_308274",
    "data-name": "Path 308274",
    d: "M6.271,24.426l.022-5.834A7.958,7.958,0,0,0,5.109,14.4c-.013-.019-.025-.039-.036-.059a9.84,9.84,0,0,1-.719-8.789A8.291,8.291,0,0,1,12.276.264a9.178,9.178,0,0,1,6.665,2.585,10.4,10.4,0,0,1,2.73,6.575,8.121,8.121,0,0,0,.676,2.991c.372.813.791,1.6,1.115,2.157a.837.837,0,0,1-.649,1.271H21.678v3.428a2.868,2.868,0,0,1-2.89,2.843H17.733v2.312",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308275",
    "data-name": "Path 308275",
    d: "M6.005,14.4l-.036-.059a9.84,9.84,0,0,1-.718-8.789A8.261,8.261,0,0,1,12.706.275c-.143-.006-.287-.01-.431-.011A8.291,8.291,0,0,0,4.354,5.552a9.84,9.84,0,0,0,.718,8.789l.036.059a7.94,7.94,0,0,1,1.185,4.192L6.27,24.426h.9l.023-5.834A7.949,7.949,0,0,0,6.005,14.4",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308276",
    "data-name": "Path 308276",
    d: "M17.734,22.378h-.015A11.8,11.8,0,0,1,13.5,21.264a.264.264,0,0,1,.219-.48,11.285,11.285,0,0,0,4.028,1.067.264.264,0,0,1-.014.527Z",
    transform: "translate(0 0)",
    fill: "#515255"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308277",
    "data-name": "Path 308277",
    d: "M8.488,14.018l.228-.4a1.453,1.453,0,0,1,.807-.665l.438-.143a1.471,1.471,0,0,0,.945-1.794,2.562,2.562,0,0,0,4.4.035,3.077,3.077,0,0,0,1.6.436A2.742,2.742,0,0,0,19.778,8.9a2.624,2.624,0,0,0-1.9-2.439,1.685,1.685,0,0,0,.163-.719,2.343,2.343,0,0,0-2.556-2.044,3.075,3.075,0,0,0-1.156.221,2.7,2.7,0,0,0-2.253-1.078A2.58,2.58,0,0,0,9.658,4.217,2.421,2.421,0,0,0,9.387,4.2,2.574,2.574,0,0,0,6.83,6.793a2.609,2.609,0,0,0,.2,1.017,2.106,2.106,0,0,0-.4,1.248,2.071,2.071,0,0,0,1.387,1.973l-1.17,1.583",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308278",
    "data-name": "Path 308278",
    d: "M12.556,5.223A2.374,2.374,0,1,1,10.182,7.6a2.374,2.374,0,0,1,2.374-2.374",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308279",
    "data-name": "Path 308279",
    d: "M11.026,7.6a2.374,2.374,0,0,1,1.952-2.336,2.444,2.444,0,0,0-.422-.038,2.374,2.374,0,0,0,0,4.748,2.444,2.444,0,0,0,.422-.038A2.374,2.374,0,0,1,11.026,7.6",
    transform: "translate(0 0)",
    fill: "#fd930d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308280",
    "data-name": "Path 308280",
    d: "M12.556,10.235A2.638,2.638,0,1,1,15.194,7.6a2.641,2.641,0,0,1-2.638,2.638m0-4.748a2.11,2.11,0,1,0,2.11,2.11,2.112,2.112,0,0,0-2.11-2.11",
    transform: "translate(0 0)",
    fill: "#515255"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308281",
    "data-name": "Path 308281",
    d: "M13.729,7.333h-.91v-.91a.264.264,0,1,0-.527,0v.91h-.91a.264.264,0,0,0,0,.528h.91V8.77a.264.264,0,1,0,.527,0V7.861h.91a.264.264,0,0,0,0-.528",
    transform: "translate(0 0)",
    fill: "#515255"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308282",
    "data-name": "Path 308282",
    d: "M7,1.366A1.714,1.714,0,0,0,5.243.291c-.571.1-.865.592-1.3.928C3.491.88,3.108.359,2.52.277A1.784,1.784,0,0,0,.756,1.366C-.137,3.4,2.676,5.474,3.947,6.594,5.224,5.469,7.893,3.4,7,1.366",
    transform: "translate(0 0)",
    fill: "#fd930d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87986",
    "data-name": "Group 87986",
    transform: "translate(0.584 0.555)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87985",
    "data-name": "Group 87985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87984",
    "data-name": "Group 87984",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308283",
    "data-name": "Path 308283",
    d: "M1.283.839A1.763,1.763,0,0,1,1.441.555a1.943,1.943,0,0,0-.686.812C-.137,3.4,2.676,5.474,3.947,6.595l.527-.528C3.2,4.947.39,2.869,1.283.839",
    transform: "translate(-0.584 -0.555)",
    fill: "#fd930d"
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308284",
    "data-name": "Path 308284",
    d: "M.686,24.162A.264.264,0,0,1,.422,23.9V20.261a.264.264,0,0,1,.528,0V23.9A.264.264,0,0,1,.686,24.162Z",
    transform: "translate(0 0)",
    fill: "#515255"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308285",
    "data-name": "Path 308285",
    d: "M3.324,24.162A.264.264,0,0,1,3.06,23.9V17.1a.264.264,0,0,1,.528,0v6.8A.264.264,0,0,1,3.324,24.162Z",
    transform: "translate(0 0)",
    fill: "#515255"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308286",
    "data-name": "Path 308286",
    d: "M18.225,6.3c.666-2.163-2.131-3.259-3.8-2.7A3.144,3.144,0,0,0,9.5,3.94,2.877,2.877,0,0,0,6.74,7.776a2.378,2.378,0,0,0,.87,3.366l-.973,1.315a.264.264,0,1,0,.424.314l1.171-1.583a.266.266,0,0,0-.128-.407A1.8,1.8,0,0,1,6.9,9.057a1.843,1.843,0,0,1,.275-.975H7.81a.264.264,0,0,1,.264.263V9.527a.864.864,0,0,0,1.728,0,.264.264,0,1,0-.528,0,.337.337,0,1,1-.673,0V8.345a.792.792,0,0,0-.791-.791H7.222A2.345,2.345,0,0,1,9.4,4.466v.6a.264.264,0,0,1-.264.263H8.815a.264.264,0,0,0,0,.528h.317a.792.792,0,0,0,.792-.791V4.274c.713-1.523,3.291-1.551,4.191-.213a.264.264,0,0,0,.318.1c1.275-.517,3.9.192,3.275,2.028h-.764a.265.265,0,0,1-.264-.264v-.4a.264.264,0,1,0-.527,0v.4a.792.792,0,0,0,.791.791h.876a2.362,2.362,0,0,1,1.7,2.181c0,1.95-2.392,2.823-3.94,2v-.608a.264.264,0,0,1,.264-.263h1.5a.864.864,0,1,0,0-1.728h-.534a.264.264,0,1,0,0,.527h.534a.337.337,0,1,1,0,.673h-1.5a.792.792,0,0,0-.792.791v.688a2.314,2.314,0,0,1-3.911-.088.264.264,0,0,0-.486.2,1.2,1.2,0,0,1-.773,1.472,2.181,2.181,0,0,0-1.393.929l-.228.4a.264.264,0,0,0,.46.26l.227-.4a1.715,1.715,0,0,1,1.1-.688,1.72,1.72,0,0,0,1.14-1.261,2.871,2.871,0,0,0,4.218-.4c1.895.945,4.643-.195,4.643-2.505A2.859,2.859,0,0,0,18.225,6.3Z",
    transform: "translate(0 0)",
    fill: "#515255"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_308287",
    "data-name": "Path 308287",
    d: "M23.694,14.438c-.387-.67-.789-1.447-1.1-2.132l0-.006a7.93,7.93,0,0,1-.649-2.876V9.4a10.668,10.668,0,0,0-2.8-6.736A9.565,9.565,0,0,0,12.224,0,8.774,8.774,0,0,0,7.317,1.449,2.008,2.008,0,0,0,5.2.032,2.593,2.593,0,0,0,3.942.877,2.873,2.873,0,0,0,2.556.016,2.056,2.056,0,0,0,.514,1.26,2.362,2.362,0,0,0,.491,3.079H.263a.264.264,0,0,0,0,.528H.734A12.34,12.34,0,0,0,3.693,6.723a10.134,10.134,0,0,0,1.155,7.755,7.8,7.8,0,0,1,1.183,4.114l-.023,5.833a.263.263,0,0,0,.263.265h0a.263.263,0,0,0,.263-.263l.024-5.833A8.32,8.32,0,0,0,5.3,14.2,9.6,9.6,0,0,1,4.252,6.679,11.261,11.261,0,0,0,7.068,3.606H7.5a.264.264,0,1,0,0-.527H7.294a2.6,2.6,0,0,0,.142-1.072A8.224,8.224,0,0,1,12.224.528a9.037,9.037,0,0,1,6.531,2.5,10.02,10.02,0,0,1,2.658,6.4,8.414,8.414,0,0,0,.7,3.093c.438.957.892,1.774,1.124,2.176.19.332.014.875-.42.875H21.683a.264.264,0,0,0-.264.264v3.429a2.605,2.605,0,0,1-2.628,2.578H17.747a11.278,11.278,0,0,1-4.024-1.066.264.264,0,1,0-.219.48,11.97,11.97,0,0,0,3.97,1.1v2.066a.263.263,0,1,0,.527,0V22.378h.79a3.135,3.135,0,0,0,3.156-3.106V16.107h.871A1.108,1.108,0,0,0,23.694,14.438ZM4.1,6.114l-.151.131A12.981,12.981,0,0,1,1.336,3.606H2.879a.262.262,0,0,0,.2-.092l.4-.465L4.053,4.23a.265.265,0,0,0,.438.056l.581-.68H6.46A11.743,11.743,0,0,1,4.1,6.114Zm2.63-3.035H4.95a.265.265,0,0,0-.2.092l-.4.466L3.776,2.456A.266.266,0,0,0,3.339,2.4l-.581.679H1.051A1.939,1.939,0,0,1,1,1.473,1.525,1.525,0,0,1,2.484.538c.528.074.9.6,1.306.893a.264.264,0,0,0,.32,0c.368-.287.684-.789,1.178-.875a1.46,1.46,0,0,1,1.471.921,2,2,0,0,1-.031,1.606",
    transform: "translate(0 0)",
    fill: "#515255"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFeature5);
export default __webpack_public_path__ + "static/media/Plan_Feature_5.cbd8569512094ac912471150d3cb6ec3.svg";
export { ForwardRef as ReactComponent };